import React, { useEffect } from "react";
import { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { getImage } from "../../api/media";

const XHRImage = ({ src, height, threshold, ...props }) => {
  const [source, setSource] = useState(
    "data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw=="
  );

  const getSource = async () => {
    try {
      if (src?.toLowerCase()?.includes("data:image")) {
        setSource(src);
      } else {
        const source = await getImage(src);

        setSource(source);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {

    if (src) {
      getSource();
    }
  }, [src]);

  const handleLazyLoad = () => {
    // setTimeout(() => {
    //   setSource(
    //     "data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mO0/Q8AAX8BPpw9emYAAAAASUVORK5CYII="
    //   );
    // }, 500);
    getSource();
    console.count("image lazyloaded");
  };

  // return <img ref={imageEl} {...props} src={source || ""} alt="" />;
  return (
    <LazyLoadImage
      beforeLoad={handleLazyLoad}
      height={height}
      threshold={threshold}
      {...props}
      src={source}
    ></LazyLoadImage>
  );
};

export { XHRImage };
